import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";

import { displayGalleryName } from "./galleryDisplay";
import "./Gallery.css";

const photoNumber = (displayName) => {
  const id = displayName.split("/").pop();
  return parseInt(id, 10) || 0;
};

const compareGalleries = (first, second) => {
  if (first.name.indexOf(".") > 0) {
    return (
      parseInt(first.name.substr(0, first.name.indexOf(".")), 10) -
      parseInt(second.name.substr(0, second.name.indexOf(".")), 10)
    );
  }
  if (first.name > second.name) {
    return 1;
  }
  if (first.name < second.name) {
    return -1;
  }
  return 0;
};

const Gallery = () => {
  const navigate = useNavigate();
  const { galleryId } = useParams();
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [galleries, setGalleries] = useState([]);
  const [crumbs, setCrumbs] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const fetchURL = "/api/gallery/" + (galleryId ? `?id=${galleryId}` : "");

    setLoading(true);
    setGalleries([]);
    setItems([]);
    setCrumbs([]);

    fetch(fetchURL)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) {
          return;
        }
        if (data.items) {
          setItems(
            [...data.items].sort(
              (first, second) =>
                photoNumber(first.displayName) -
                photoNumber(second.displayName)
            )
          );
        } else {
          setItems([]);
        }
        if (data.galleries) {
          const rootGallery = !galleryId;
          setGalleries(
            [...data.galleries].sort((first, second) => {
              const order = compareGalleries(first, second);
              return rootGallery ? -order : order;
            })
          );
        } else {
          setGalleries([]);
        }
        if (data.crumbs) {
          setCrumbs(data.crumbs);
        } else {
          setCrumbs([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [galleryId]);

  return (
    <React.Fragment>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <div className="crumbContainer">
          {crumbs.slice(-2).map((crumb, order) => (
            <React.Fragment key={crumb.id}>
              {order + 1 === crumbs.length ? (
                <div className={"chiefCrumb"}>
                  {displayGalleryName(crumb.name)}
                </div>
              ) : (
                <div
                  className={"oldCrumb"}
                  onClick={() =>
                    navigate(
                      crumb.id === null ? "/gallery" : `/gallery/${crumb.id}`
                    )
                  }
                >
                  {displayGalleryName(crumb.name)}
                </div>
              )}
              {order + 1 < crumbs.length && (
                <span className="arrow" aria-hidden="true">
                  /
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
      {!isLoading && galleries.length > 0 && (
        <div className="galleryCardsContainer">
          {galleries.map((gallery, idx) => (
            <Card
              className="galleryCard"
              key={gallery.id}
              onClick={() => navigate(`/gallery/${gallery.id}`)}
              raised={false}
              style={{ order: idx }}
            >
              <CardHeader
                titleTypographyProps={{ variant: "h3" }}
                title={displayGalleryName(gallery.name)}
              />
              <CardContent>
                <div className="imageContainerXYZ">
                  {gallery.keyItem ? (
                    <img
                      alt={`${gallery.keyItem.displayName}`}
                      className="scalableImage"
                      src={gallery.keyItem.thumbnailUrl}
                    />
                  ) : (
                    <div className="scalableImage galleryCardPlaceholder" />
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
      {!isLoading && items.length > 0 && (
      <div className="thumbnailCardsContainer">
        {items.map((item) => (
            <React.Fragment
              style={{ order: photoNumber(item.displayName) }}
              key={item.id}
            >
              <div className="cardGrid">
                <div
                  className="imageContainerXYZ"
                  key={item.id}
                  onClick={() => navigate(`/item/${item.id}`)}
                >
                  <img
                    alt={item.displayName}
                    className="scalableImage"
                    src={item.thumbnailUrl}
                  />
                </div>
                <h3 className="imageTitle">
                  {" "}
                  {item.displayName
                    .substring(item.displayName.indexOf("/"))
                    .substring(1)}{" "}
                </h3>
              </div>
            </React.Fragment>
          ))}
      </div>
      )}
    </React.Fragment>
  );
};

export default Gallery;
